document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.review-page-hero__tab');
  const sections = document.querySelectorAll('.tab-section');

  if (tabs.length > 0 && sections.length > 0) {
    const firstTab = tabs[0];
    const firstTabId = firstTab.getAttribute('data-tab-id');
    firstTab.classList.add('active');

    sections.forEach(section => {
      if (section.classList.contains(`section-${firstTabId}`)) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    });

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab-id');

        if (tabId) {
          tabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');

          sections.forEach(section => {
            if (section.classList.contains(`section-${tabId}`)) {
              section.classList.remove('hidden');
            } else {
              section.classList.add('hidden');
            }
          });
        }
      });
    });
  }
});